import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { useAppSelector } from "../../../../redux/hooks";
import { apiClient } from "../../../../zodios/client";

export const useGetV4ProductReportOptions = () => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  return queryOptions({
    queryKey: [{ entity: "V4ProductReportByAd", marketPlace }],
    queryFn: async () =>
      await apiClient.getV4ProductReportOptions({
        queries: {
          marketplace: marketPlace,
        },
      }),
    placeholderData: keepPreviousData,
  });
};
